<template>
  <div class="upgrade">
    <div class="upgrade_title">
      温馨提醒：尊敬的用户，您现在使用的Internet
      Explore浏览器版本过低存在安全隐患，建议您升级至高版本或使用其他浏览器。
    </div>
    <div class="upgrade_select">
      <a href="https://browser.360.cn/ee/">
        <div class="upgrade_select_item">
          <img class="upgrade_img mb20" src="@/assets/360.png" alt="" />
          <a-button type="primary"
            >360浏览器<a-icon type="right" />
          </a-button></div
      ></a>
      <a href="https://www.mozilla.org/zh-CN/firefox/">
        <div class="upgrade_select_item">
          <img class="upgrade_img mb20" src="@/assets/Firefox.png" alt="" />
          <a-button type="primary"
            >Firefox浏览器<a-icon type="right" />
          </a-button></div
      ></a>
      <a href="https://ie.sogou.com/">
        <div class="upgrade_select_item">
          <img class="upgrade_img mb20" src="@/assets/sougou.png" alt="" />
          <a-button type="primary">搜狗浏览器<a-icon type="right" /> </a-button>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang='scss'>
.upgrade {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
  flex-direction: column;
  .upgrade_title {
    font-size: 24px;
    width: 800px;
  }
  .upgrade_select {
    display: flex;
    align-items: center;
    justify-content: center;
    .upgrade_select_item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      //   background-color: #2d8cf0;
      width: 200px;
      height: 250px;
      margin: 1px 20px;
      .upgrade_img {
        height: 100px;
        width: 100px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/upgrade.vue